import { css } from "@emotion/react"
import cx from "classnames"
import React, { PropsWithChildren } from "react"

interface PrimaryButtonProps
  extends PropsWithChildren<React.ButtonHTMLAttributes<HTMLButtonElement>> {
  isLoading?: boolean
}

export function PrimaryButton({
  children,
  disabled,
  isLoading = false,
  ...props
}: PrimaryButtonProps) {
  return (
    <button
      className={cx(
        "btn lg-btn filled-btn primary-btn w-100%",
        isLoading && "loading-btn",
      )}
      css={css`
        height: 44px;
      `}
      disabled={disabled || isLoading}
      {...props}
    >
      <span className="spinner" aria-hidden="true" />
      {children}
    </button>
  )
}
